module.exports = __webpack_public_path__ + "static/media/success_animation.314dde7.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success_animation.webm
// module id = E6I4
// module chunks = 9